import { ActivitiesCounterProps } from './types';

import * as S from './styles';

const ActivitiesCounter: React.FC<ActivitiesCounterProps> = ({
  cognitoId,
  doneActivities,
  totalActivities,
}) => {
  const handleRediretToEUActivitiesPage = () => {
    window.open(`/new-provider/enduser/${cognitoId}/activities`, '_blank');
  };

  const text = `${doneActivities}/${totalActivities}`;

  if (
    doneActivities !== undefined &&
    doneActivities >= 0 &&
    totalActivities !== undefined &&
    totalActivities >= 0
  ) {
    return (
      <S.ActivitiesCounterContainer
        data-testid="activitiesCounter"
        onClick={handleRediretToEUActivitiesPage}
      >
        <S.ActivitiesCounter>{text}</S.ActivitiesCounter>
        <S.LinkIcon />
      </S.ActivitiesCounterContainer>
    );
  }
  return <>-</>;
};

export default ActivitiesCounter;
